import { observer } from "mobx-react";
import Subjects from "../../models/subjects";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "@ant-design/pro-components";
import { Button, Divider, Flex, List, Typography } from "antd";
import { RollbackOutlined } from '@ant-design/icons';
import { useEffect } from "react";
import { useStore } from "../../stores/root-store";
import StudentTaskItem from "./student-task-item";

const StudentCurrentTicket: React.FC<{ subject: Subjects }> = ({ subject }) => {

    const { studentId, ticketId } = useParams();
    const { subjectStores, authStore } = useStore();
    const navigate = useNavigate();

    const studentTicket = subjectStores[subject].studentTicket;

    useEffect(() => {

        if (authStore.isAuthenticated) {
            studentTicket.loadTicket(studentId, ticketId);
        }
    }, [authStore.isAuthenticated, studentTicket, studentId, ticketId]
    );

    const { Text } = Typography;

    const handleGoBack = () => {
        navigate(-1);
    }

    const handleCheckingComplete = () => {
        studentTicket.finish();
    }

    const handleSaveAll = () => {
        studentTicket.saveAll();
    }

    return (
        <div className="content">
            <PageHeader title={`${studentTicket.studentName ? (studentTicket.studentName + ". ") : ""}Проверочный вариант ${studentTicket.ticketId || ""}`}
                className="site-page-header" />
            <Button type='link' onClick={handleGoBack}><RollbackOutlined />Вернуться</Button>
            <Divider />
            <List
                loading={studentTicket.loading}
                itemLayout="vertical"
                dataSource={studentTicket.tasks}
                renderItem={(item, indx) => (
                    <StudentTaskItem {...{ task: item, indx: indx, subject: subject }} />
                )}
            ></List>
            <Divider />
            <Flex justify="flex-end" gap="middle">
                {studentTicket.pointsSum && <Text strong>{`Набрано баллов ${studentTicket.pointsSum}`}</Text>}
                <Button onClick={handleSaveAll} type="primary">Сохранить всё</Button>
                <Button onClick={handleCheckingComplete} type="primary" danger>Завершить проверку</Button>
            </Flex>
        </div>
    );
}

export default observer(StudentCurrentTicket);